import { render, staticRenderFns } from "./parallelClassInfo.vue?vue&type=template&id=687746b5&scoped=true&"
import script from "./parallelClassInfo.vue?vue&type=script&lang=js&"
export * from "./parallelClassInfo.vue?vue&type=script&lang=js&"
import style0 from "./parallelClassInfo.vue?vue&type=style&index=0&id=687746b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687746b5",
  null
  
)

export default component.exports